import { create } from 'zustand';

type BlockRequestStore = {
  blockRequest: boolean;
  setBlockRequest(value: boolean): void;
};

export const useBlockRequestStore = create<BlockRequestStore>((set) => ({
  blockRequest: false,
  setBlockRequest(value: boolean) {
    set(() => ({ blockRequest: value }));
  },
}));
